import styled from 'styled-components';

export const StyledNotFound = styled.div`
    margin-top: -${({ theme }) => theme.spacing.lg};
`;
